import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-gray-300 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 mb-12">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <div className="mb-4">
              <a href="/">
                <img src="/assets/img/logo-white.png" alt="Trademark IP US" className="h-12" />
              </a>
              {/* <span className="text-3xl font-bold text-white">Trademark IP US</span> */}
            </div>
            <p className="text-sm text-gray-400 leading-relaxed mb-6 max-w-md">
              Your trusted partner for trademark registration and intellectual property protection. We provide professional legal services to safeguard your brand's identity and ensure long-term success.
            </p>
            <div className="space-y-2">
              <p className="text-sm text-gray-400">
                <span className="font-semibold text-white">Email:</span> info@trademarkipus.com
              </p>
              <p className="text-sm text-gray-400">
                <span className="font-semibold text-white">Phone:</span> +1 (888) 430-8390
              </p>
              <p className="text-sm text-gray-400">
                <span className="font-semibold text-white">Address:</span> 3800 Barham Blvd, Los Angeles, CA 90068
              </p>
            </div>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Our Services</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/services/trademark-registration" className="text-sm text-gray-400 hover:text-[#fd5a27] transition-colors flex items-center">
                  <span className="w-1.5 h-1.5 bg-[#fd5a27] rounded-full mr-2"></span>
                  Trademark Registration
                </Link>
              </li>
              <li>
                <Link to="/services/copyright-registration" className="text-sm text-gray-400 hover:text-[#fd5a27] transition-colors flex items-center">
                  <span className="w-1.5 h-1.5 bg-[#fd5a27] rounded-full mr-2"></span>
                  Copyright Registration
                </Link>
              </li>
              <li>
                <Link to="/services/company-formation" className="text-sm text-gray-400 hover:text-[#fd5a27] transition-colors flex items-center">
                  <span className="w-1.5 h-1.5 bg-[#fd5a27] rounded-full mr-2"></span>
                  Company Formation
                </Link>
              </li>
              <li>
                <Link to="/services/trademark-search" className="text-sm text-gray-400 hover:text-[#fd5a27] transition-colors flex items-center">
                  <span className="w-1.5 h-1.5 bg-[#fd5a27] rounded-full mr-2"></span>
                  Trademark Search
                </Link>
              </li>
              <li>
                <Link to="/services/amazon-brand-registry" className="text-sm text-gray-400 hover:text-[#fd5a27] transition-colors flex items-center">
                  <span className="w-1.5 h-1.5 bg-[#fd5a27] rounded-full mr-2"></span>
                  Amazon Brand Registry
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-gray-400 hover:text-[#fd5a27] transition-colors flex items-center">
                  <span className="w-1.5 h-1.5 bg-[#fd5a27] rounded-full mr-2"></span>
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-gray-400 hover:text-[#fd5a27] transition-colors flex items-center">
                  <span className="w-1.5 h-1.5 bg-[#fd5a27] rounded-full mr-2"></span>
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-sm text-gray-400 hover:text-[#fd5a27] transition-colors flex items-center">
                  <span className="w-1.5 h-1.5 bg-[#fd5a27] rounded-full mr-2"></span>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-bold text-lg mb-4">Legal</h3>
            <ul className="space-y-3">
              <li>
                <a href="/terms-conditions" className="text-sm text-gray-400 hover:text-[#fd5a27] transition-colors flex items-center">
                  <span className="w-1.5 h-1.5 bg-[#fd5a27] rounded-full mr-2"></span>
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="/privacy-policy" className="text-sm text-gray-400 hover:text-[#fd5a27] transition-colors flex items-center">
                  <span className="w-1.5 h-1.5 bg-[#fd5a27] rounded-full mr-2"></span>
                  Privacy Policy
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-400 mb-4 md:mb-0">
              © {new Date().getFullYear()} Trademark IP US. All rights reserved.
            </p>
            <p className="text-xs text-gray-500">
              * Government filing fees not included in service prices | Professional trademark services since 2015
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
